import { animate, useMotionValue, useReducedMotion } from 'framer-motion'
import { useEffect, useMemo, useState } from 'react'

import { cn } from '../../lib/utils'

const toNumber = (value) => {
  const numberValue = Number(value)
  return Number.isFinite(numberValue) ? numberValue : 0
}

export function AnimatedNumber({
  value,
  className,
  prefix = '',
  suffix = '',
  minimumFractionDigits = 0,
  maximumFractionDigits = 0,
  duration = 0.7,
}) {
  const numericValue = toNumber(value)
  const shouldReduceMotion = useReducedMotion()
  const motionValue = useMotionValue(0)
  const formatter = useMemo(
    () =>
      new Intl.NumberFormat('en-IN', {
        minimumFractionDigits,
        maximumFractionDigits,
      }),
    [maximumFractionDigits, minimumFractionDigits],
  )
  const [displayValue, setDisplayValue] = useState(() => formatter.format(0))

  useEffect(() => {
    if (shouldReduceMotion) {
      motionValue.set(numericValue)
      setDisplayValue(formatter.format(numericValue))
      return undefined
    }

    const controls = animate(motionValue, numericValue, {
      duration,
      ease: 'easeOut',
      onUpdate: (latest) => {
        setDisplayValue(formatter.format(latest))
      },
    })

    return () => controls.stop()
  }, [duration, formatter, motionValue, numericValue, shouldReduceMotion])

  return (
    <span className={cn('tabular-nums', className)}>
      {prefix}
      {displayValue}
      {suffix}
    </span>
  )
}
